import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { displayOsloDateWithTime } from "./displayOsloDateWithTime";
import { momentLocaleFor } from "./i18nFormatters";

export const useDisplayOsloDateWithTime = () => {
  const { t, i18n } = useTranslation();
  const locale = momentLocaleFor(i18n.language);
  return useCallback((value: string) => displayOsloDateWithTime(value, t("at"), locale), [t, locale]);
};
